import {observable} from 'mobx'
//plugin
import axios from 'axios'
//config
import config from '../config'

class Profile {
  @observable username='';
  @observable apiKey='';
  @observable alias='';
  fetchProfile(){
    let self = this;
    axios.get(`${config.env.server}/api/profile`)
    .then(function(response){
      self.apiKey = response.data.apiKey;
      self.username = response.data.username;
      self.alias = response.data.alias;
    })
    .catch((error) => console.log(error))
  }
  emptyProfile(){
    this.username = '';
    this.apiKey = '';
  }
}

var profile = new Profile;

export default profile;



// WEBPACK FOOTER //
// ./src/store/profile.js